import { route } from "ziggy-js"

export default {
  sign(proposalId, params) {
    return axios.post(route("client-portal.proposals.sign", { proposal: proposalId }), params)
  },

  paymentMethodIntent(proposalId) {
    return axios.post(route("client-portal.proposals.payment-method-intent", { proposal: proposalId }))
  },

  savePaymentMethod(proposal, setupIntent) {
    return axios.post(
      route("client-portal.proposals.stripe-payment-method", {
        proposal,
        setup_intent_id: setupIntent.id,
      }),
    )
  },

  downloadTermsAndConditions(proposal) {
    return axios.get(route("client-portal.proposals.terms_and_conditions.download", proposal))
  },

  calculate(proposal, params) {
    return axios.post(route("client-portal.proposals.calculate", proposal), params)
  },
}
